import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppContext } from '../contexts/app-context';
import { useSessionActions } from '../hooks/use-session-actions';
import { AppBanners, MaintenanceBanner } from './alliance/app-banners';
import { AppShellBar } from './app-shell-bar';
import { RouteErrorBoundary } from './route-container/route-error-boundary';

/**
 * The signed-in shell: one App Bar (with the nav drawer below md) above
 * every page, the banners under it, then the page outlet.
 *
 * The outlet sits in a route error boundary (inline crash, or "University
 * has been updated" for a failed lazy chunk) and is keyed so "Try again" on
 * a page that didn't load remounts it.
 *
 * @param maintenanceEnd - Set while maintenance is active for an admin; shows
 *   the admins-only maintenance banner
 */
export function Dashboard(props: { maintenanceEnd?: string | null }) {
  // Context
  const { state } = React.useContext(AppContext);
  // Hooks
  const { signOut } = useSessionActions();

  return (
    <div>
      <AppShellBar />
      <AppBanners />

      {props.maintenanceEnd ? (
        <MaintenanceBanner until={props.maintenanceEnd} onSignOut={signOut} />
      ) : null}

      <RouteErrorBoundary>
        <React.Fragment key={state.routeKey}>
          <Outlet />
        </React.Fragment>
      </RouteErrorBoundary>
    </div>
  );
}
